:host {
  /* Size */
  --width: var(--jb-input-width, 100%);
  --height: var(--jb-input-height, var(--jb-control-height-md, 2.5rem));
  --border-radius: var(--jb-input-border-radius, var(--jb-radius));
  --border-width: var(--jb-input-border-width, 1px);
  --border-bottom-width: var(--jb-input-border-bottom-width, 3px);
  --border-width-focus: var(--jb-input-border-width-focus, var(--border-width));
  --border-bottom-width-focus: var(--jb-input-border-bottom-width-focus, var(--border-bottom-width));
  /* put message and label forward base on border radius*/
  --inline-space: var(--jb-input-inline-space, min(calc(var(--border-radius) / 1.75), calc(var(--height) / 2)));
  --label-margin: var(--jb-input-label-margin, 0.125rem var(--inline-space));
  --label-font-size: var(--jb-input-label-font-size, 0.8rem);
  --value-font-size: var(--jb-input-value-font-size, 1rem);
  --input-padding: var(--jb-input-input-padding, 0.125rem 0.75rem 0 0.75rem);
  --placeholder-font-size: var(--jb-input-placeholder-font-size, var(--value-font-size));
  --message-font-size: var(--jb-input-message-font-size, 0.7rem);
  --message-padding: var(--jb-input-message-padding, 0.125rem var(--inline-space));
  --inline-slots-padding: var(--jb-input-inline-slots-padding, 0.375rem 0.625rem);
  /* Colors */
  --border-color: var(--jb-input-border-color, var(--jb-neutral-10));
  --message-color: var(--jb-input-message-color, var(--jb-content-secondary));
  --label-color: var(--jb-input-label-color, var(--jb-content-primary));
  --value-color: var(--jb-input-value-color, var(--jb-content-primary));
  --clear-icon-color: var(--jb-input-clear-icon-color, currentColor);
  --placeholder-color: var(--jb-input-placeholder-color, var(--jb-neutral-6));
  --control-bg-color: var(--jb-input-bg-color, var(--jb-surface-secondary));
  /* Other */
  --margin: var(--jb-input-margin, 0 0);
  --label-font-weight: var(--jb-input-label-font-weight, 300);
  --box-margin: var(--jb-control-margin, 0px);
  --box-overflow: var(--jb-control-overflow, hidden);
  --box-shadow: var(--jb-control-shadow);
  --box-shadow-focus: var(--jb-control-shadow-focus);
  --box-corner-shape: var(--jb-input-corner-shape, var(--jb-corner-shape));
  --input-text-align: var(--jb-input-input-text-align, initial);
  --input-direction: var(--jb-input-input-direction, inherit);
  --input-font-weight: var(--jb-input-input-font-weight, initial);
  --message-box-display: var(--jb-input-message-box-display, block);
}

:host(:state(invalid)) {
  --message-color: var(--jb-input-message-color-error, var(--jb-red));
}

:host(:state(disabled)) {
  cursor: not-allowed;
  --control-bg-color: var(--jb-input-bg-color-disabled, hsl(from var(--jb-surface-secondary) h 12% 66.1));
  --value-color: var(--jb-input-value-color-disabled, var(--jb-neutral-3));
}

:host(:focus-within) {
  --border-color: var(--jb-input-border-color-focus, var(--jb-neutral));
}

/* Size */
:host([size="xs"]) {
  --height: var(--jb-input-height-xs, var(--jb-control-height-xs, 1.5rem));
  --value-font-size: var(--jb-input-value-font-size-xs, 0.75rem);
  --label-font-size: var(--jb-input-label-font-size-xs, 0.6rem);
  /*0.7 - (0.0875 *2) */
  --message-font-size: var(--jb-input-message-font-size-xs, 0.525rem);
  /* 0.375 = radius-xs - (0.25*radius-xs) */
  --input-padding: var(--jb-input-input-padding-xs, 0.125rem 0.375rem 0 0.375rem);
  --border-radius: var(--jb-input-border-radius-xs, var(--jb-radius-xs));
  --inline-slots-padding: var(--jb-input-inline-slots-padding-xs, 0.125rem 0.25rem);
}

:host([size="sm"]) {
  --height: var(--jb-input-height-sm, var(--jb-control-height-sm, 2rem));
  --value-font-size: var(--jb-input-value-font-size-sm, 0.875rem);
  --label-font-size: var(--jb-input-label-font-size-sm, 0.7rem);
  --message-font-size: var(--jb-input-message-font-size-sm, 0.6125rem);
  --input-padding: var(--jb-input-input-padding-sm, 0.125rem 0.5625rem 0 0.5625rem);
  --border-radius: var(--jb-input-border-radius-sm, var(--jb-radius-sm));
  --inline-slots-padding: var(--jb-input-inline-slots-padding-sm, 0.25rem 0.5rem);
}

:host([size="lg"]) {
  --height: var(--jb-input-height-lg, var(--jb-control-height-lg, 3rem));
  --value-font-size: var(--jb-input-value-font-size-lg, 1.125rem);
  --label-font-size: var(--jb-input-label-font-size-lg, 0.9rem);
  /*0.7 + 0.0875*/
  --message-font-size: var(--jb-input-message-font-size-lg, 0.7875rem);
  --input-padding: var(--jb-input-input-padding-lg, 0.125rem 0.9375rem 0 0.9375rem);
  --border-radius: var(--jb-input-border-radius-lg, var(--jb-radius-lg));
  --inline-slots-padding: var(--jb-input-inline-slots-padding-lg, 0.5rem 0.75rem);
}

:host([size="xl"]) {
  --height: var(--jb-input-height-xl, var(--jb-control-height-xl, 4rem));
  --value-font-size: var(--jb-input-value-font-size-xl, 1.25rem);
  --label-font-size: var(--jb-input-label-font-size-xl, 1rem);
  --message-font-size: var(--jb-input-message-font-size-xl, 0.875rem);
  --input-padding: var(--jb-input-input-padding-xl, 0.125rem 1.125rem 0 1.125rem);
  --border-radius: var(--jb-input-border-radius-xl, var(--jb-radius-xl));
  --inline-slots-padding: var(--jb-input-inline-slots-padding-xl, 0.75rem 1rem);
}
